<template>
<m-pageframe
    title="Search Incidents"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px;"
>
    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
        autocomplete="off"
    >
        <span
            slot="append-outer"
        >
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickNew()"
                >
                    <v-list-item-title>New...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </span>
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.date="{ item }">
            {{$rc.pretty(item.creation_time,'date')}}
        </template>

        <template v-slot:item.time="{ item }">
            {{$rc.pretty(item.creation_time,'time')}}
        </template>

        <template v-slot:item.show_banner="{ item }">
            <v-chip
                v-if="item.show_banner_home_page"
            >
                Home Page
            </v-chip>
            <v-chip
                v-if="item.show_banner_bulk_message"
                style="margin-left: 5px;"
            >
                Bulk Message
            </v-chip>
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickEdit(item)"
                >
                    <v-list-item-title>Edit...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickCopy(item)"
                >
                    <v-list-item-title>Copy...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickViewDetails(item)"
                >
                    <v-list-item-title>View Details...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickDelete(item)"
                >
                    <v-list-item-title>Delete...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <m-incident-detail-dialog
        ref="detail-dialog"
    />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {

    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Date', value: 'date'},
                { text: 'Time', value: 'time'},
                { text: 'State', value: 'state'},
                { text: 'Home Page Open Banner', value: 'open_text_home_page'},
                { text: 'Show Banner', value: 'show_banner'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },
    
    methods: {

        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /incidents',
            
                {
                    'full_text' : this.full_text,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.results = data.results;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onClickNew(item)
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'NEW: /incidents',
            
                {
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.doUpdate();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to create a new incident');
                },
            );
        },

        onClickEdit(item)
        {
            this.$router.push({
                'name': 'incident-edit',
                'params' : {
                    'incident_id' : item.incident_id,
                }
            });
        },

        onClickCopy(item)
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'COPY: /incidents/:incident_id',
            
                {
                    'incident_id' : item.incident_id,
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.doUpdate();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onClickViewDetails(item)
        {
            this.$refs['detail-dialog'].showDialog(item.incident_id);
        },

        onClickDelete(item)
        {
            this.$rc.confirm(
                'Delete Incident',
                'Delete this incident.  This can not be undone.',
                [
                    {'text' : 'Cancel', 'value' : 'cancel' },
                    {'text' : 'Delete', 'value' : 'confirm' },
                ],
                (response) => {
                    if ( response != 'confirm' ) return;
                    this.doDelete(item);
                },
            );
        },

        doDelete(item)
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'DELETE: /incidents/:incident_id',
            
                {
                    'incident_id' : item.incident_id,
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.doUpdate();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to delete incident');
                },
            );
        },
    },
}
</script>

<style lang="scss" scoped>
</style>